import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "@reach/router";

import ActivityLoader from "../../ActivityLoader";
import { navBarContext } from "./../../../contexts/navBarContext";
import AngleRight from "../../utility/AngleRight";

const EachNavItemWithOutSubCategory = ({ eachCategory }) => {
  return (
    <EachMenuContainer>
      <EachSideNavMenu to={eachCategory.permalink}>
        {eachCategory.nepaliName}
      </EachSideNavMenu>
    </EachMenuContainer>
  );
};

const EachNavItem = ({ eachCategory }) => {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <EachMenuContainer
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <EachSideNavMenu to={eachCategory.permalink}>
        {eachCategory.nepaliName}
      </EachSideNavMenu>
      {eachCategory.subCategories ? (
        <IconWrapper>
          <AngleRight />
        </IconWrapper>
      ) : null}
      <AnimatePresence>
        {isHovered && (
          <SubCategoriesContainer
            initial={{ x: "-18rem", opacity: 0 }}
            animate={{ x: "18rem", opacity: 1 }}
            exit={{ x: "-18rem", opacity: 0 }}
            transitionEnd={{ display: "none" }}
          >
            {eachCategory.subCategories.map((eachSubCat) => (
              <EachMenuContainer sub={true} key={eachSubCat.permalink}>
                <EachSideNavMenu to={eachSubCat.permalink}>
                  {eachSubCat.nepaliName}
                </EachSideNavMenu>
              </EachMenuContainer>
            ))}
          </SubCategoriesContainer>
        )}
      </AnimatePresence>
    </EachMenuContainer>
  );
};

const SideNav = ({ sideNavLoading, sideNavCategoryData }) => {
  const {
    navBarState: { sideNavVisibility },
    toggleSideNav,
  } = useContext(navBarContext);

  useEffect(() => {
    const handleKeyDownEsc = (e) => {
      if (e.key === "Escape") {
        toggleSideNav();
      }
    };
    if (sideNavVisibility) {
      window.addEventListener("keydown", handleKeyDownEsc);
      return () => {
        window.removeEventListener("keydown", handleKeyDownEsc);
      };
    }
  }, [sideNavVisibility, toggleSideNav]);

  if (sideNavLoading) {
    return <ActivityLoader />;
  }

  const { getCategoriesSideMenu } = sideNavCategoryData;
  return (
    <AnimatePresence>
      {sideNavVisibility && (
        <SideNavContainer
          onMouseLeave={() => toggleSideNav()}
          initial={{ x: -600 }}
          animate={{ x: 0 }}
          exit={{ x: -600 }}
          transitionEnd={{ display: "none" }}
        >
          <EachMenuContainer>
            <EachSideNavMenu to="/">मुख्य पृष्ठ</EachSideNavMenu>
          </EachMenuContainer>
          {getCategoriesSideMenu.map((eachCategory) => {
            if (eachCategory.subCategories) {
              return (
                <EachNavItem
                  eachCategory={eachCategory}
                  key={eachCategory.permalink}
                />
              );
            } else {
              return (
                <EachNavItemWithOutSubCategory
                  eachCategory={eachCategory}
                  key={eachCategory.permalink}
                />
              );
            }
          })}
          <EachMenuContainer>
            <EachSideNavMenu to="/epapers">इ-पेपर</EachSideNavMenu>
          </EachMenuContainer>
        </SideNavContainer>
      )}
    </AnimatePresence>
  );
};

const SideNavContainer = styled(motion.nav)`
  position: fixed;
  top: 0;
  z-index: 200;
  height: 100vh;
  width: 20rem;
  background-color: #f5f5f5;
  border-right: 1px solid #b2b2b2;
  box-shadow: 1px 0px 3px 1px #f0f0f0;
  padding: 5rem 0;
`;

const EachSideNavMenu = styled(Link)`
  text-decoration: none;
  color: #333;
  padding: 1rem;
  flex: 1;
`;

const EachMenuContainer = styled.div`
  font-size: 1.75rem;
  position: relative;
  z-index: ${({ sub }) => (sub ? "400" : "150")};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f0f0f0;
  }

  &:active {
    background-color: #dadada;
  }
`;

const IconWrapper = styled.div`
  padding: 0 0.5rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;
`;

const SubCategoriesContainer = styled(motion.div)`
  position: absolute;
  width: 15rem;
  top: -50%;
  transform: translateY(50%);
  background-color: #f5f5f5;
  transition: all 0.5s;
  border: 1px solid #b2b2b2;
  z-index: 500;

  &::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    border-right: 1px solid #aaa;
    border-bottom: 1px solid #aaa;
    transform: translateY(-50%) translateX(-50%) rotate(135deg);
    height: 2rem;
    width: 2rem;
    background-color: #f5f5f5;
    z-index: 300;
  }
`;

export default SideNav;
